import classNames from 'classnames';
import React, {CSSProperties, HTMLProps} from 'react';
import styles from './CLMaskIcon.module.scss';
import addAutomationTag from 'common/src/modules/automation/utils/addAutomationTag';
import {AutomationProps} from 'common/src/modules/automation/automation.types';

export interface CLMaskIconProps extends AutomationProps, Omit<HTMLProps<HTMLDivElement>, 'size'> {
  src: string;
  size?: string;
  bgColor?: string;
}

function CLMaskIcon({
  src,
  className = '',
  bgColor,
  size,
  style: htmlStyles,
  qaHook = '',
  ...htmlProps
}: CLMaskIconProps) {
  const style: CSSProperties = {
    ...htmlStyles,
    WebkitMask: `url(${src}) no-repeat center/contain`,
    mask: `url(${src}) no-repeat center/contain`,
  };

  if (bgColor) {
    style.backgroundColor = bgColor;
  }

  if (size) {
    style.width = size;
    style.height = size;
  }

  return (
    <div
      {...(qaHook && {
        ...addAutomationTag(`${qaHook}-mask-icon`),
      })}
      {...htmlProps}
      className={classNames(styles.common_cl_mask_icon, className)}
      style={style}
    />
  );
}

export default CLMaskIcon;
